import { produce } from "immer";
import {
  type AffiliateActions,
  CHANGE_SALES_PARTNER,
  CLEAR_SALES_PARTNER,
  REPLACE_SALES_PARTNER_CONTEXT,
  UPDATE_SUBSIDIARY,
} from "~/domains/affiliate/redux/actions";
import type { SalesPartnerContextData } from "~/domains/affiliate/types/models";

export interface AffiliateStore {
  savedAffiliate?: SalesPartnerDTO;
  previousSavedAffiliate?: SalesPartnerDTO;
  savedSubsidiaryId?: string;
  previousSavedSubsidiaryId?: string;
  visitedAffiliate?: SalesPartnerDTO;
}

export const preferredSalesPartnerInitialState: AffiliateStore = {
  savedAffiliate: undefined,
  savedSubsidiaryId: undefined,
  visitedAffiliate: undefined,
};

export const affiliateStoreFromSession = (context?: SalesPartnerContextData): AffiliateStore => ({
  savedAffiliate: context?.preferred?.salesPartner ?? undefined,
  savedSubsidiaryId: context?.preferred?.selectedSubsidiaryId ?? undefined,
  visitedAffiliate: context?.visitedSalesPartner ?? undefined,
});

export const affiliateReducer = (
  state = preferredSalesPartnerInitialState,
  action: AffiliateActions,
): AffiliateStore => {
  return produce(state, (draft) => {
    switch (action.type) {
      case REPLACE_SALES_PARTNER_CONTEXT: {
        if (!action.payload) {
          delete draft.savedAffiliate;
          delete draft.savedSubsidiaryId;
          delete draft.visitedAffiliate;
          delete draft.previousSavedAffiliate;
          delete draft.previousSavedSubsidiaryId;
          break;
        }
        const next = affiliateStoreFromSession(action.payload);
        draft.savedAffiliate = next.savedAffiliate;
        draft.savedSubsidiaryId = next.savedSubsidiaryId;
        draft.visitedAffiliate = next.visitedAffiliate;
        break;
      }

      case CHANGE_SALES_PARTNER: {
        const { subsidiaryId, affiliate } = action.payload;
        draft.previousSavedAffiliate = draft.savedAffiliate;
        draft.savedAffiliate = affiliate;
        draft.previousSavedSubsidiaryId = draft.savedSubsidiaryId;
        draft.savedSubsidiaryId = subsidiaryId;
        break;
      }

      case CLEAR_SALES_PARTNER: {
        delete draft.savedAffiliate;
        delete draft.savedSubsidiaryId;
        break;
      }

      case UPDATE_SUBSIDIARY: {
        // Don't save previous value.
        // draft.previousSavedSubsidiaryId = draft.savedSubsidiaryId;
        draft.savedSubsidiaryId = action.payload;
        break;
      }
    }
  });
};
